import { useContext } from 'react';
import { CompoundFilterContext } from '../../CompoundFilter.context';

export const useCompoundFilterContext = () => useContext(CompoundFilterContext);
